import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { MatIconModule } from '@angular/material/icon';
import { PasswordResetModule } from '../password-reset/password-reset.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecuperarPasswordComponent } from './recuperar-password.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
    RecuperarPasswordComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    PasswordResetModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    RecuperarPasswordComponent
  ]
})
export class RecuperarPasswordModule { }